// "To produce" notes page, the New note modal and the navbar bell
const en = {
  title: 'To Produce',
  subtitle: 'Notes about parts and components that need to be produced, sent between colleagues',
  newTask: '+ New Note',
  sendToProduce: 'To produce',
  tabReceived: 'Received',
  tabSent: 'Sent',
  tabAll: 'All (Admin)',
  showDone: 'Show done',
  emptyTitle: 'No notes',
  emptyMessage: 'Notes sent to you or by you will show up here.',
  colItem: 'Item',
  colQuantity: 'Qty',
  colFrom: 'From',
  colTo: 'To',
  colNote: 'Note',
  colStatus: 'Status',
  colDate: 'Date',
  status_open: 'Open',
  status_in_progress: 'In progress',
  status_done: 'Done',
  type_part: 'Part',
  type_component: 'Component',
  type_text: 'Text only',
  itemType: 'What needs producing?',
  selectPart: 'Select a part...',
  selectComponent: 'Select a component...',
  lowStockFirst: 'Low stock parts are listed first',
  lowStockTag: 'low stock',
  stockInfo: 'Stock: {{qty}} (min {{min}})',
  componentStockInfo: 'Stock: {{qty}}',
  quantity: 'Quantity',
  note: 'Note',
  notePlaceholder: 'e.g. needed by Friday for order #123',
  recipients: 'Send to',
  selectRecipients: 'Select one or more colleagues...',
  send: 'Send',
  sending: 'Sending...',
  sent: 'Sent to {{count}} recipient(s)',
  failedToSend: 'Failed to send: {{error}}',
  failedToLoad: 'Failed to load notes: {{error}}',
  failedToUpdate: 'Failed to update: {{error}}',
  confirmDelete: 'Delete this note?',
  markDone: 'Mark done',
  start: 'Start',
  reopen: 'Reopen',
  doneBy: 'done by {{name}}',
  notifications: 'Notifications',
  noNotifications: 'No new notes',
  markAllRead: 'Mark all as read',
  viewAll: 'View all',
  newBadge: 'new',
  soundOn: 'Sound on (click to mute)',
  soundOff: 'Sound off (click to unmute)',
  comments: 'Comments',
  noComments: 'No messages yet. Write the first one below.',
  writeMessage: 'Write a message... (Enter to send, Shift+Enter for new line)',
  newComment: 'New message',
};

const de = {
  title: 'Zu produzieren',
  subtitle: 'Notizen zu Teilen und Komponenten, die produziert werden müssen, an Kollegen gesendet',
  newTask: '+ Neue Notiz',
  sendToProduce: 'Zu produzieren',
  tabReceived: 'Erhalten',
  tabSent: 'Gesendet',
  tabAll: 'Alle (Admin)',
  showDone: 'Erledigte anzeigen',
  emptyTitle: 'Keine Notizen',
  emptyMessage: 'Notizen an Sie oder von Ihnen erscheinen hier.',
  colItem: 'Artikel',
  colQuantity: 'Menge',
  colFrom: 'Von',
  colTo: 'An',
  colNote: 'Notiz',
  colStatus: 'Status',
  colDate: 'Datum',
  status_open: 'Offen',
  status_in_progress: 'In Arbeit',
  status_done: 'Erledigt',
  type_part: 'Teil',
  type_component: 'Komponente',
  type_text: 'Nur Text',
  itemType: 'Was muss produziert werden?',
  selectPart: 'Teil auswählen...',
  selectComponent: 'Komponente auswählen...',
  lowStockFirst: 'Teile mit niedrigem Bestand stehen oben',
  lowStockTag: 'niedriger Bestand',
  stockInfo: 'Bestand: {{qty}} (min. {{min}})',
  componentStockInfo: 'Bestand: {{qty}}',
  quantity: 'Menge',
  note: 'Notiz',
  notePlaceholder: 'z. B. bis Freitag für Auftrag #123 benötigt',
  recipients: 'Senden an',
  selectRecipients: 'Einen oder mehrere Kollegen auswählen...',
  send: 'Senden',
  sending: 'Wird gesendet...',
  sent: 'An {{count}} Empfänger gesendet',
  failedToSend: 'Senden fehlgeschlagen: {{error}}',
  failedToLoad: 'Notizen konnten nicht geladen werden: {{error}}',
  failedToUpdate: 'Aktualisierung fehlgeschlagen: {{error}}',
  confirmDelete: 'Diese Notiz löschen?',
  markDone: 'Erledigt',
  start: 'Starten',
  reopen: 'Wieder öffnen',
  doneBy: 'erledigt von {{name}}',
  notifications: 'Benachrichtigungen',
  noNotifications: 'Keine neuen Notizen',
  markAllRead: 'Alle als gelesen markieren',
  viewAll: 'Alle anzeigen',
  newBadge: 'neu',
  soundOn: 'Ton an (klicken zum Stummschalten)',
  soundOff: 'Ton aus (klicken zum Einschalten)',
  comments: 'Kommentare',
  noComments: 'Noch keine Nachrichten. Schreiben Sie unten die erste.',
  writeMessage: 'Nachricht schreiben... (Enter zum Senden, Umschalt+Enter für neue Zeile)',
  newComment: 'Neue Nachricht',
};

const productionTasks = { en, de };
export default productionTasks;
